import * as React from 'react';
import Loader from '../../Components/Loader/Loader';
import { ReactElement } from 'react';

type LoaderProviderProps = {
  isLoading: boolean;
};

const LoaderProvider: React.FunctionComponent<LoaderProviderProps> = ({
  isLoading,
  children,
}): ReactElement => {
  return <React.Fragment>{isLoading ? <Loader /> : children}</React.Fragment>;
};

export default LoaderProvider;
